import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=f96b2850&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
import style0 from "./Projects.vue?vue&type=style&index=0&id=f96b2850&prod&scoped=true&lang=css"
import style1 from "./Projects.vue?vue&type=style&index=1&id=f96b2850&prod&lang=css"
import style2 from "./Projects.vue?vue&type=style&index=2&id=f96b2850&prod&lang=css"
import style3 from "./Projects.vue?vue&type=style&index=3&id=f96b2850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96b2850",
  null
  
)

export default component.exports